<template>
  <b-modal id="addComment" size="md" class="modal has-overflow">
          <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
          <template v-slot:modal-header>
          <div class="w-100">
            <h4 class="e-mtavr-17 e-bold modal-title">ახალი კომენტარი</h4>
          </div>
          </template>
          <b-form>
              <div class="row no-gutters row-bordered">
            <!-- Login -->
            <div class="col-md-12">
              <div class="px-4 px-sm-5 pt-4 pb-5 pb-sm-5">
                <b-form-group label="კომენტარი" class="e-nusx-8 e-bold text-muted">
                  <b-form-textarea v-model="comment"
                  placeholder="მიუთითეთ გადაწყვეტილების მიზეზი"
                  rows="7"
                  max-rows="7">
                  </b-form-textarea>
                </b-form-group>
              </div>
            </div>
              </div>
          </b-form>
          <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              size="sm"
              variant="btn btn-primary"
              @click="save()"
              class="float-right e-mtavr-17"
            >შენახვა</b-button>
            <b-button
              size="sm"
              variant="btn btn-secondary"
              @click="close('addComment')"
              class="float-right e-mtavr-17 mr-2"
            >გაუქმება</b-button>
          </div>
          </template>
  </b-modal>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
export default {
  props: ['blRecord'],
  data () {
    return {
      loading: false,
      comment: '',
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
    }
  },
  methods: {
    close (id) {
      this.$bvModal.hide(id)
    },
    save () {
      if (this.blRecord.status) {
        this.blRecord.status = false
      } else {
        this.blRecord.status = true
      }
      BaseService.ChangeBlackListStatus(this.header, this.blRecord.id, this.blRecord.status ? 1 : 0, this.comment)
        .then(res => {
          if (res.data.success) {
            this.comment = ''
            this.$bvModal.hide('addComment')
            this.$emit('statusChanged')
          }
        })
    }
  }
}
</script>
